import { FormInput, Input } from '@/core/ui/forms/input'
import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import { useFormContext } from 'react-hook-form'

const FormPhoneInput = dynamic(
  () => import('@/core/ui/forms/phone-input').then(mod => mod.FormPhoneInput),
  { ssr: false, loading: () => <Input disabled /> },
)

type Props = {
  className?: string
}
export const MyDetails: React.FC<Props> = ({ className }) => {
  const t = useTranslations()
  const { control } = useFormContext()
  return (
    <div className={`flex flex-col gap-5 ${className}`}>
      <h6 className='font-medium'>{t('trip.myDetails')}</h6>
      <div className='flex flex-col gap-3 sm:flex-row'>
        <FormInput
          label={t('forms.nameLabel')}
          labelClassName='text-sm font-medium'
          control={control}
          name='fullName'
          placeholder={t('forms.namePH')}
          className='w-full'
        />
        <FormInput
          label={t('forms.emailLabel')}
          labelClassName='text-sm font-medium'
          name='email'
          control={control}
          placeholder={t('forms.emailPH')}
          type='email'
          className='w-full'
        />
      </div>
      <div className='flex gap-3'>
        <FormPhoneInput
          label={t('forms.phoneLabel')}
          labelClassName='text-sm font-medium'
          name='phoneNumber'
          control={control}
          placeholder={t('forms.phonePH')}
          className='w-full flex-1'
        />
        <div className='hidden flex-1 sm:block'></div>
      </div>
    </div>
  )
}
